<template>
  <with-actions v-if="customer">
    <customer-form v-model="customer"></customer-form>
    <div class="row mt-4">
      <div class="col-md-2 text-right"></div>
      <div class="col-md-5">
        <button class="btn btn-success btn-lg" @click="spin($event, save)">{{ 'save' | t }}</button>
      </div>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import $ from 'jquery';

export default {
  data: function () {
    return {
      customer: null
    };
  },
  mounted: function () {
    Api.find('customers', this.customer_id, {
      fields: { plans: 'id,name' },
      include: 'payment_term,billed_plan'
    })
      .then(({ data }) => {
        this.customer = data;
      })
      .catch(function () {
        console.error('Failed loading carrier type');
      });
  },
  props: ['customer_id'],
  methods: {
    save(event) {
      if (this.customer && this.customer.id) {
        Api.update(
          'customers',
          _.omit(this.customer, [
            'organization',
            'quote',
            'subscription',
            'invoices',
            'taggings',
            'credit_cards',
            'customer_notes',
            'onboarding_agent',
            'sales_agent',
            'customer_success_agent',
            'change_logs',
            'replaced_subscriptions',
            'discounts'
          ])
        )
          .then(({ data, errors, meta, links }) => {
            this.$router.push({
              name: 'customers_show',
              params: { customer_id: data.id }
            });
            $(event.target).loading(false);
          })
          .catch(({ errors }) => {
            Alerts.danger({ title: errors[0].title, detail: errors[0].detail });
            $(event.target).loading(false);
          });
      }
    }
  }
};
</script>
